module.exports = __webpack_public_path__ + "img/normal.6bbb94f7.svg";